(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const touchOrSmallScreen = window.matchMedia('(pointer: coarse), (max-width: 749px)');
  const scrollLockClasses = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop',
    'modal-open',
    'signature-loader-scroll-locked',
  ];
  const nativeScrollSelector = [
    '[data-native-scroll]',
    '[data-lenis-prevent]',
    '[role="dialog"]',
    '[aria-modal="true"]',
    'cart-drawer',
    'menu-drawer',
    'modal-dialog',
    'pickup-availability-drawer',
    '.drawer',
    '.drawer__inner',
    '.drawer__contents',
    '.cart-drawer',
    '.menu-drawer',
    '.mobile-facets__inner',
    '.predictive-search',
    '.size-guide-modal',
    '.size-guide-modal__content',
    '.product-media-modal',
    '.product-media-modal__content',
    '.slider',
    'input',
    'textarea',
    'select',
    'iframe',
    '[contenteditable="true"]',
  ].join(',');

  let lenis = null;
  let animationFrame = null;
  let bodyObserver = null;

  function shouldDisableSmoothScroll() {
    return (
      reduceMotion.matches ||
      touchOrSmallScreen.matches ||
      document.documentElement.classList.contains('shopify-design-mode') ||
      window.Shopify?.designMode ||
      typeof window.Lenis !== 'function'
    );
  }

  function isDrawerOrModalOpen() {
    const bodyLocked = scrollLockClasses.some((className) => document.body.classList.contains(className));
    const openDialog = document.querySelector(
      '[aria-modal="true"][open], [role="dialog"][open], cart-drawer.active, .size-guide-modal.is-open'
    );

    return bodyLocked || Boolean(openDialog);
  }

  function stopSmoothScroll() {
    if (!lenis) return;

    lenis.stop();
  }

  function startSmoothScroll() {
    if (!lenis || isDrawerOrModalOpen()) return;

    lenis.start();
  }

  function syncSmoothScrollState() {
    if (isDrawerOrModalOpen()) {
      stopSmoothScroll();
    } else {
      startSmoothScroll();
    }
  }

  function shouldUseNativeScroll(node) {
    if (!node?.closest) return false;
    if (node.closest(nativeScrollSelector)) return true;

    let element = node;

    while (element && element !== document.body && element !== document.documentElement) {
      if (canElementScroll(element)) return true;
      element = element.parentElement;
    }

    return false;
  }

  function canElementScroll(element) {
    const styles = window.getComputedStyle(element);
    const overflowY = styles.overflowY;
    const overflowX = styles.overflowX;
    const canScrollY = /(auto|scroll|overlay)/.test(overflowY) && element.scrollHeight > element.clientHeight + 1;
    const canScrollX = /(auto|scroll|overlay)/.test(overflowX) && element.scrollWidth > element.clientWidth + 1;

    return canScrollY || canScrollX;
  }

  function raf(time) {
    lenis?.raf(time);
    animationFrame = requestAnimationFrame(raf);
  }

  function initSmoothScroll() {
    if (shouldDisableSmoothScroll()) return;

    try {
      lenis = new window.Lenis({
        duration: 0.85, // Softer luxury glide. Lower to 0.55 if it ever feels resistant.
        easing: (t) => 1 - Math.pow(1 - t, 3), // Quick response with a gentle deceleration tail.
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 0.95, // Slightly slower than native, but close enough to stay responsive.
        touchMultiplier: 1,
        prevent: shouldUseNativeScroll,
      });
    } catch (error) {
      lenis = null;
      return;
    }

    window.lenis = lenis;
    document.documentElement.classList.add('smooth-scroll-ready');

    bodyObserver = new MutationObserver(syncSmoothScrollState);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('shopify:section:load', () => {
      lenis?.resize();
      syncSmoothScrollState();
    });

    window.addEventListener('resize', () => lenis?.resize(), { passive: true });

    syncSmoothScrollState();
    animationFrame = requestAnimationFrame(raf);
  }

  window.stopSmoothScroll = stopSmoothScroll;
  window.startSmoothScroll = startSmoothScroll;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.collection-campaign-hero__link[href^="#"]');
    if (!link || !lenis || reduceMotion.matches || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;

    event.preventDefault();
    const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
    window.history.pushState(null, '', link.hash);
    lenis.scrollTo(target, {
      offset: -offset,
      onComplete: () => target.focus({ preventScroll: true }),
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothScroll);
  } else {
    initSmoothScroll();
  }

  window.addEventListener('pagehide', () => {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    bodyObserver?.disconnect();
    lenis?.destroy();
    lenis = null;
  });
})();
